<template>
    <div>
        <submit-form width="70%" 
        :title="form.title" 
        :visible.sync="form.visible" 
        :formData="form.data" 
        :items="form.items"
        :rules="form.rules" 
        :action="form.action" 
        :fileImageList="form.imageList"
        addUrl="/api/platform/createSysNotice"
        updateUrl="/api/platform/updateSysNotice"
        :onSubmitCallback="()=>$emit('onSubmitCallback')" 
        :handleClose="()=>$emit('handleClose')"
        :onBeforeSubmit="beforeSubmit"></submit-form>
    </div>
</template>

<script>
import submitForm from '../plugin/mume-submit-form.vue';
export default {
    components:{submitForm},
    name:'notice-lapyer',
    props:{
        
    },
    data() {
        return {
            form: {
                title: '新建群发',
                visible: false,
                action:'add',
                imageList:[],
                data: {
                    title: "",
                    content: '',
                    type: 1,
                    image:'',
                    thirdLink:'',
                    groupId:''
                },
                items: [{
                    key: "title",
                    name: "title",
                    label: "通知标题",
                    type: "input",
                    prop: "title"
                }, {
                    key: "image",
                    name: "image",
                    label: "图片",
                    type: "uploadAuto",
                    prop: "image"
                },{
                key:"content",
                name:"content",
                label:"通知内容",
                type:"editor",
                prop:"content",
                editorOption:{}
                }, {
                    key: "thirdLink",
                    name: "thirdLink",
                    label: "三方链接",
                    type: "input",
                    prop: "thirdLink"
                }, {
                    key: "type",
                    name: "type",
                    label: "通知方式",
                    type: "radio",
                    options: [{
                        value: '1',
                        label: "系统通知"
                    }, {
                        value: '2',
                        label: "弹窗"
                    }]
                }, {
                    key: "groupId",
                    name: "groupId",
                    label: "接受对象",
                    type: "input",
                    placeholder:'请输入组Id，0代表全部',
                    prop: "groupId"
                }],
                rules: {
                    title: [{ required: true, message: '请输入通知标题', trigger: 'blur' }],
                    content: [{ required: true, message: '请输入通知内容', trigger: 'blur' }],
                }
            }
        }
    },
    methods:{
        open(data){
            this.form.data =data || {
                    title: "",
                    content: '',
                    type: '1',
                    image:'',
                    thirdLink:'',
                    groupId:''
                }
            this.form.imageList=[]
            if(this.form.data.id){
                this.form.title = '编辑群发'
                this.form.action = 'edit'
                if(this.form.data.groupId==0)
                {
                    this.form.data.groupId = undefined
                }
                if(this.form.data.image){
                    this.form.imageList.push({url:this.form.data.image,response:this.form.data.image})
                }
            }
            this.form.visible = true;
        },
        close(){
            this.form.visible = false;
        },
        beforeSubmit(data){
            if(!data.groupId){
                data.groupId = 0
            }else{
                data.groupId = Number(data.groupId)
            }
        }
    }
}
</script>

<style></style>


// WEBPACK FOOTER //
// src/components/system/notice-lapyer.vue